<template>
<div>
  <h1 v-if="item.extra === 'main'">{{ item.value }}</h1>
  <h2 v-else>{{ item.value }}</h2>
</div>
</template>

<script>
import itemMixin from '@/components/appUser/questionnaires/pageItems/itemMixin'

export default {
  name: 'TitleItem',
  mixins: [itemMixin]
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 50px;
}
h2 {
  font-size: 30px;
}
</style>
